export const OFFERS = 'offers';
export const LIST = 'list';
export const CLAIM_POINTS = 'claimPoints';
export const HISTORY = 'history';
export const REWARDS = 'rewards';
